// @file    fa-lucide.map.ts
// @created 2026-07-01 by Claude
// @desc    Canonical Font Awesome -> Lucide (kebab) icon name map for the IHUB
//          v2 host-match redesign. Every target was validated to exist as
//          node_modules/lucide-angular/icons/<name>.d.ts. Used by the
//          faToLucide pipe (dynamic icons) and the lucide-icons provider
//          (which registers exactly these targets via LucideAngularModule.pick).

/** FA bare glyph name (without the `fa-` prefix) -> Lucide kebab name. */
export const FA_LUCIDE: Record<string, string> = {
  'arrow-left': 'arrow-left',
  'arrow-right': 'arrow-right',
  'chevron-right': 'chevron-right',
  'chevron-left': 'chevron-left',
  'chevron-down': 'chevron-down',
  'xmark': 'x',
  'times': 'x',
  'check': 'check',
  'check-double': 'check-check',
  'bell': 'bell',
  'bell-slash': 'bell-off',
  'arrow-up-right-from-square': 'external-link',
  'right-from-bracket': 'log-out',
  'arrow-right-from-bracket': 'log-out',
  'download': 'download',
  'cloud-arrow-down': 'cloud-download',
  'print': 'printer',
  'paper-plane': 'send',
  'comment': 'message-circle',
  'hashtag': 'hash',
  'tag': 'tag',
  'language': 'languages',
  'fingerprint': 'fingerprint-pattern',
  'sparkles': 'sparkles',
  'sun': 'sun',
  'tasks': 'list-checks',
  'timeline': 'list-checks',
  'inbox': 'inbox',
  'circle-exclamation': 'circle-alert',
  'exclamation-circle': 'circle-alert',
  'exclamation-triangle': 'triangle-alert',
  'triangle-exclamation': 'triangle-alert',
  'exclamation': 'triangle-alert',
  'circle-check': 'circle-check',
  'check-circle': 'circle-check',
  'circle-xmark': 'circle-x',
  'times-circle': 'circle-x',
  'circle-info': 'info',
  'info-circle': 'info',
  'question': 'circle-question-mark',
  'question-circle': 'circle-question-mark',
  'clock': 'clock',
  'clock-rotate-left': 'history',
  'rotate-right': 'rotate-cw',
  'bolt': 'zap',
  'certificate': 'award',
  'wallet': 'wallet',
  'credit-card': 'credit-card',
  'coins': 'coins',
  'gift': 'gift',
  'piggy-bank': 'piggy-bank',
  'dollar-sign': 'dollar-sign',
  'money-bill-wave': 'banknote',
  'money-bill-trend-up': 'trending-up',
  'sack-dollar': 'hand-coins',
  'hand-holding-dollar': 'hand-coins',
  'receipt': 'receipt',
  'file-invoice-dollar': 'receipt',
  'ticket': 'ticket',
  'chart-simple': 'chart-column',
  'chart-pie': 'chart-pie',
  'calendar': 'calendar',
  'calendar-days': 'calendar-days',
  'calendar-day': 'calendar',
  'calendar-check': 'calendar-check',
  'calendar-xmark': 'calendar-x',
  'calendar-plus': 'calendar-plus',
  'hourglass-half': 'hourglass',
  'user': 'user',
  'users': 'users',
  'user-shield': 'shield-user',
  'user-check': 'user-check',
  'id-card': 'id-card',
  'person-circle-exclamation': 'circle-alert',
  'headset': 'headset',
  'shield-halved': 'shield-half',
  'shield-alt': 'shield',
  'shield-heart': 'shield-check',
  'file-contract': 'file-text',
  'file-lines': 'file-text',
  'file-pdf': 'file-text',
  'file-pen': 'file-pen',
  'file-shield': 'file-check',
  'file-medical': 'clipboard-plus',
  'notes-medical': 'clipboard-plus',
  'kit-medical': 'briefcase-medical',
  'box': 'package',
  'ban': 'ban',
  'edit': 'square-pen',
  'heart': 'heart',
  'heart-pulse': 'heart-pulse',
  'heartbeat': 'heart-pulse',
  'heart-crack': 'heart-crack',
  'hand-holding-medical': 'hand-heart',
  'umbrella': 'umbrella',
  'umbrella-beach': 'umbrella',
  'graduation-cap': 'graduation-cap',
  'house': 'house',
  'house-circle-check': 'house',
  'phone': 'phone',
  'phone-volume': 'phone-call',
  'envelope': 'mail',
  'location-dot': 'map-pin',
  'map-pin': 'map-pin',
  'map-marker-alt': 'map-pin',
  'map-marked-alt': 'map',
  'university': 'landmark',
  'car-burst': 'car',
  'spinner': 'loader-circle',
  'facebook-f': 'facebook',
  'qrcode': 'qr-code',
};

/** Fallback Lucide name when a FA class can't be resolved. */
export const LUCIDE_FALLBACK = 'circle-alert';
